import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import LanguageDetector from "i18next-browser-languagedetector";
import { ReactNode, useEffect, useState } from "react";
import { KeycloakProvider } from "react-keycloak-manager";
import { IKeycloakConf } from "react-keycloak-manager/dist/Entities";
import { BrowserRouter } from "react-router-dom";
import { VevyThemeProvider } from "react-vevy-mui-theme";
import ShowInfo from "./ShowInfo";

export default function VevyLibrary({
	children,
	settings,
}: {
	settings: IKeycloakConf;
	children: ReactNode;
}) {
	const [currLang, setCurrLang] = useState("en");
	const [showInfo, setShowInfo] = useState(false);

	const handleShowInfo = () => {
		setShowInfo((s) => !s);
	};

	useEffect(() => {
		var detector = new LanguageDetector();
		var result = detector.detect();
		if (!Array.isArray(result)) setCurrLang(result?.slice(0, 2) ?? "en");
	}, []);

	useEffect(() => {
		window.addEventListener("showInfo", handleShowInfo);
		return () => {
			window.removeEventListener("showInfo", handleShowInfo);
		};
	}, []);

	return (
		<BrowserRouter>
			<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={currLang}>
				<KeycloakProvider configuration={settings}>
					<CssBaseline />
					<VevyThemeProvider>
						<CssBaseline />
						{showInfo && <ShowInfo />}
						{children}
					</VevyThemeProvider>
				</KeycloakProvider>
			</LocalizationProvider>
		</BrowserRouter>
	);
}
